/**
 * ResolutionListener Hook
 * 
 * Escuta eventos DOM de resolução disparados pelo ResolutionDetector
 * e envia para o LiveComponent MenuCalendar
 */

export const ResolutionListenerHook = {
  mounted() {
    console.warn('🎧 [ResolutionListener] Hook mounted on element:', this.el.id);
    
    this.handleResolutionDetected = (event) => {
      console.warn('🎧 [ResolutionListener] Received resolution-detected event:', event.detail);
      
      // Envia o evento para o LiveComponent via pushEventTo
      this.pushEventTo(this.el, 'resolution_changed', event.detail);
      
      console.warn('🎧 [ResolutionListener] Event forwarded to LiveComponent');
    };
    
    this.el.addEventListener('resolution-detected', this.handleResolutionDetected);
    console.log('🎧 [ResolutionListener] Event listener attached');
  },
  
  destroyed() {
    if (this.handleResolutionDetected) {
      this.el.removeEventListener('resolution-detected', this.handleResolutionDetected);
    }
  }
};
